import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm fixed top-0 left-0 right-0 z-50" data-id="element-150">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="flex justify-between h-16 items-center" data-id="element-152">
          <div className="flex-shrink-0 flex items-center" data-id="element-153">
            <h1 className="text-2xl font-bold text-indigo-600" data-id="element-154">Turnout</h1>
          </div>
          {/* Desktop menu */}
          <nav className="hidden md:flex space-x-8" data-id="element-155">
            <a href="#services" className="text-gray-700 hover:text-indigo-600 px-3 py-2 text-sm font-medium" data-id="element-156">
              Services
            </a>
            <a href="#about" className="text-gray-700 hover:text-indigo-600 px-3 py-2 text-sm font-medium" data-id="element-157">
              About
            </a>
            <a href="#team" className="text-gray-700 hover:text-indigo-600 px-3 py-2 text-sm font-medium" data-id="element-158">
              Team
            </a>
            <a href="#portfolio" className="text-gray-700 hover:text-indigo-600 px-3 py-2 text-sm font-medium" data-id="element-159">
              Portfolio
            </a>
            <a href="#testimonials" className="text-gray-700 hover:text-indigo-600 px-3 py-2 text-sm font-medium" data-id="element-160">
              Testimonials
            </a>
            <a href="#contact" className="text-gray-700 hover:text-indigo-600 px-3 py-2 text-sm font-medium" data-id="element-161">
              Contact
            </a>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-162">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-indigo-600 focus:outline-none" data-id="element-163">
              {isMenuOpen ? <X size={24} data-id="element-164" /> : <Menu size={24} data-id="element-165" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white shadow-lg" data-id="element-166">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-167">
            <a href="#services" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600" onClick={() => setIsMenuOpen(false)} data-id="element-168">
              Services
            </a>
            <a href="#about" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600" onClick={() => setIsMenuOpen(false)} data-id="element-169">
              About
            </a>
            <a href="#team" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600" onClick={() => setIsMenuOpen(false)} data-id="element-170">
              Team
            </a>
            <a href="#portfolio" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600" onClick={() => setIsMenuOpen(false)} data-id="element-171">
              Portfolio
            </a>
            <a href="#testimonials" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600" onClick={() => setIsMenuOpen(false)} data-id="element-172">
              Testimonials
            </a>
            <a href="#contact" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600" onClick={() => setIsMenuOpen(false)} data-id="element-173">
              Contact
            </a>
          </div>
        </div>}
    </header>;
}